module.exports = __webpack_public_path__ + "img/paper.1a81cc6d.svg";